import * as React from "react";

import dynamic from "next/dynamic";
import Head from "next/head";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import AgapeLoading from "../../../components/common/loading/Loading";
import {
  getApiService,
  getOrganizationPayment,
  getOrganizationPublicOnePage,
} from "../../../services/AgapeAPI";
import Error404 from "../../../components/common/404/404";
import { serverTokenGetter } from "../../../helpers/serverTokenGetter";

// import Cookies from 'universal-cookie';

const PaymentmethodsMobile = dynamic(
  () =>
    import("../../../components/other/paymentMethods/PaymentmethodsDesktop"),
  { loading: () => <AgapeLoading internal={false} /> }
);

const PaymentmethodsDesktop = dynamic(
  () =>
    import("../../../components/other/paymentMethods/PaymentmethodsDesktop"),
  { loading: () => <AgapeLoading internal={false} /> }
);

// const cookies = new Cookies();

const PaymentMethods = ({
  data,
  orgData,
  done,
  info,
  globalProps2,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {data && data.payment_page_seo && (
        <Head>
          <title>{data.payment_page_seo.title}</title>
          <meta
            property="og:image"
            content={data.payment_page_seo["og:image"]}
          />
          <meta
            property="og:site_name"
            content={data.payment_page_seo["og:site_name"]}
          />
          <meta
            property="og:title"
            content={data.payment_page_seo["og:title"]}
          />
          <meta property="og:type" content={data.payment_page_seo["og:type"]} />
          <meta property="og:url" content={data.payment_page_seo["og:url"]} />
          <meta
            property="twitter:creator"
            content={data.payment_page_seo["twitter:creator"]}
          />
          <meta
            property="twitter:description"
            content={data.payment_page_seo["twitter:description"]}
          />
          <meta
            property="twitter:image"
            content={data.payment_page_seo["twitter:image"]}
          />
          <meta
            property="twitter:site"
            content={data.payment_page_seo["twitter:site"]}
          />
          <meta
            property="twitter:title"
            content={data.payment_page_seo["twitter:title"]}
          />
          <meta
            name="description"
            content={data.payment_page_seo.description}
          />
        </Head>
      )}
      {data ? (
        isMobile ? (
          <PaymentmethodsMobile
            {...props}
            data={data}
            orgData={orgData}
            info={info}
            globalProps2={globalProps2}
          />
        ) : (
          <PaymentmethodsDesktop
            {...props}
            data={data}
            orgData={orgData}
            info={info}
            globalProps2={globalProps2}
          />
        )
      ) : (
        done && <Error404 />
      )}
    </>
  );
};

export async function getServerSideProps(context) {
  const { params } = context;
  const globalProps = {};
  const globalProps2 = {};
  const res = await getApiService("crypto/units");

  const info = [];
  res.data.forEach((el) => {
    info.push({ label: el.name, value: el.id });
  });
  await getOrganizationPayment(params.id).then((response) => {
    globalProps.data = response.data;
  });
  const token = await serverTokenGetter(context);
  await getOrganizationPublicOnePage(encodeURI(params.slug), token)
    .then((response, requ) => {
      globalProps2.data = response.data.data;
    })
    .catch((e) => {})
    .finally(() => {
      globalProps.done = true;
      globalProps2.done = true;
    });

  // not used

  // await getUserData()
  //   .then((response) => {
  //     globalProps.user = response.data;
  //   })
  //   .catch((e) => {});

  // await getOrganizationPublic(encodeURI(params.slug)).then((response) => {
  //   globalProps.orgData = response.data;
  // });

  return {
    props: { info, ...globalProps, globalProps2 },
  };
}

PaymentMethods.getLayout = function getLayout(page) {
  return <>{page}</>;
};

export default PaymentMethods;
